<div class="journey-launched-box">
  <div class="journey-launched-icon"></div>
  @if (errors < recipients || fileJobSuccess) {
    <h3 i18n="First part of message shown when an experience is successfully launched">All set!</h3>
  }
  @if (!scheduleTime) {
    @if (errors < recipients || fileJobSuccess) {
      <h3 i18n="Second part of message show when an experience is successfully launched">Your experience is on its way!</h3>
    }
    @if (recipients && errors) {
      <h3>Error count: {{ errors }} of {{ recipients }}</h3>
    }
  }
  @if (scheduleTime) {
    <h3 i18n="Second part of message show when an experience is successfully scheduled">Your experience will launch</h3>
    <h3 id="schedule-time">{{ scheduleTime | date: 'short' }}</h3>
  }
</div>
<br/>
<div>
  @if (leftButtonLabel) {
    <div class="pull-left">
      <div class="btn btn-lg btn-primary" (click)="leftButtonClick.emit()" id="left-button">
        {{leftButtonLabel}}
      </div>
    </div>
  }
  @if (rightButtonLabel) {
    <div class="pull-right">
      <div class="btn btn-lg btn-primary" (click)="rightButtonClick.emit()" id="right-button">
        {{rightButtonLabel}}
      </div>
    </div>
  }
</div>
